import React from 'react';

/**
 *Avatar Frame Renderer
 */
export const avatarFrameRender = (mode, frame, isWebCoinShopMobilePage) => {
  switch (frame) {
    case 'Rare':
      return {
        backgroundImage: `url(${mode ? '/assets/images/web-coin/avatar-rare-frame.webp' : '/assets/images/web-coin/avatar-rare-frame-light.webp'})`,
        animation: 'rotate 2s linear infinite',
      };
    case 'Epic':
      return {
        backgroundImage: `url(${mode ? '/assets/images/web-coin/avatar-epic-frame.webp' : '/assets/images/web-coin/avatar-epic-frame-light.webp'})`,
        animation: 'rotate 2s linear infinite',
      };
    case 'Legendary':
      return {
        backgroundImage: `url(${mode ? '/assets/images/web-coin/avatar-legendary-frame.webp' : '/assets/images/web-coin/avatar-legendary-frame-light.webp'})`,
        width: !isWebCoinShopMobilePage ? 135 : '',
        height: !isWebCoinShopMobilePage ? 125 : '',
        animation: 'rotate 2s linear infinite',
      };
    case 'energyExtra':
      return {
        backgroundImage: `url(${mode ? '/assets/images/web-coin/energy-extra.webp' : '/assets/images/web-coin/energy-extra-light.webp'})`,
        width: !isWebCoinShopMobilePage ? 130 : '',
        height: !isWebCoinShopMobilePage ? 130 : '',
      };
    default:
      return {
        backgroundImage: `url(${mode ? '/assets/images/web-coin/avatar-no-frame.png' : '/assets/images/web-coin/avatar-no-frame-light.png'})`,
      };
  }
};

/**
 * Avatar Frames Title renderer
 */
export const onCommonRender = (frame) => {
  switch (frame) {
    case 'Rare':
      return (
        <span
          className={
            'badge-avatar-rare text-text300 flex items-center justify-center'
          }
        >
          Rare
        </span>
      );
    case 'Epic':
      return (
        <span
          className={
            'badge-avatar-epic text-text300 flex items-center justify-center'
          }
        >
          Epic
        </span>
      );
    case 'Legendary':
      return (
        <span
          className={
            'badge-avatar-legendary text-text300 flex items-center justify-center'
          }
        >
          Legendary
        </span>
      );
    default:
      return (
        <p
          className="text-text400 mb-0 text-xs font-semibold"
          style={{ marginTop: 7 }}
        >
          Common
        </p>
      );
  }
};
/**
 * Avatar Frames Border Style renderer
 */
export const borderStyleRenderer = (type) => {
  switch (type) {
    case 'Rare':
      return {
        border: 'solid 2px #aee9ff',
        animation: 'glowingRare 2s linear infinite',
      };
    case 'Epic':
      return {
        border: 'solid 2px #b375da',
        animation: 'glowingEpic 2s linear infinite',
      };
    case 'Legendary':
      return {
        border: 'solid 2px #8e7c3b',
        animation: 'glowingLegend 2s linear infinite',
      };
    default:
      return {
        border: 'none',
      };
  }
};
